import { useState } from "react";
import getFormattedMessageWithScope from "../../../utils/getFormattedMessageWithScope";
import { LanguageSelect } from "../../components/LanguageSelect";
import "./style.css";

const fm = getFormattedMessageWithScope("components.Header");

interface HeaderProps {
    creditorName?: string;
    logoUrl?: string;
}

// TODO: think about render inside root or with a wrapper instead of render it
// in each view (let's if the header will always be the same in the next future)
export const Header = ({ creditorName, logoUrl }: HeaderProps) => {
    const [hasErrorLoadingLogo, setHasErrorLoadingLogo] = useState(false);

    function onErrorLoadingLogo() {
        setHasErrorLoadingLogo(true);
    }

    return (
        <div className="c-Header">
            <div className="c-Header-company-logo">
                {logoUrl && (
                    <img
                        alt="company logo"
                        src={logoUrl}
                        onError={onErrorLoadingLogo}
                        className={
                            hasErrorLoadingLogo
                                ? "c-Header-company-logo-image-not-visible"
                                : undefined
                        }
                    />
                )}
            </div>
            <div className="c-Header-creditor">
                {fm("paymentRequestByCreditor")}{" "}
                <span className="c-Header-creditor-name">
                    {creditorName ? creditorName : "-"}
                </span>
            </div>
            <div className="c-Header-language-select">
                <LanguageSelect />
            </div>
        </div>
    );
};
